export default class ClassList {
  constructor(classList) {
    this.classList = Array.from(classList);
  }

  has(className) {
    return this.classList.indexOf(className) !== -1;
  }

  add(...classNames) {
    classNames.forEach((className) => {
      if (!this.has(className)) {
        this.classList.push(className);
      }
    });

    return this;
  }

  remove(...classNames) {
    classNames.forEach((className) => {
      var indexOf = this.classList.indexOf(className);
      if (indexOf !== -1) {
        this.classList.splice(indexOf, 1);
      }
    });

    return this;
  }

  applyTo($element) {
    $element.className = this.classList.join(' ');
    return $element;
  }

  sameAs(classList) {
    var isTheSame = true;

    if (classList.length === this.classList.length) {
      classList.forEach((className) => {
        if (!this.has(className)) {
          isTheSame = false;
        }
      });
    } else {
      isTheSame = false;
    }

    return isTheSame;
  }
}
